"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHeadingCss = void 0;
const helpers_1 = require("../helpers");
const getHeadingCss = (themeId, themeProps) => {
    const { properties: styleProps } = themeProps;
    const getFontFamily = (font) => {
        if (font !== "Default") {
            return (0, helpers_1.getFontFamilyName)(font, (0, helpers_1.headerStyleToFontVariant)([]));
        }
        return;
    };
    return `
        .${themeId} h2, .${themeId} h3, .${themeId} h4, .${themeId} h5, .${themeId} h6, 
    
        .${themeId} h2 {
          font-size: ${styleProps.headings.h2.size}em;
          font-family:  ${getFontFamily(styleProps.headings.h2.font)};
          font-weight: 600;
          padding: 0.6em 0em;
        }
    
        .${themeId} h3 {
          font-size: ${styleProps.headings.h3.size}em;
          font-family: ${getFontFamily(styleProps.headings.h3.font)};
          font-weight: 600;
          padding: 0.6em 0em;
        }
    
        .${themeId} h4 {
          font-size: ${styleProps.headings.h4.size}em;
          font-family: ${getFontFamily(styleProps.headings.h4.font)};
          font-weight: 600;
          padding: 0.6em 0em;
        }
    
        .${themeId} h5 {
          font-size: ${styleProps.headings.h5.size}em;
          font-family: ${getFontFamily(styleProps.headings.h5.font)};
          font-weight: 600;
          padding: 0.6em 0em;
        }
    
        .${themeId} h6 {
          font-size: ${styleProps.headings.h6.size}em;
          font-family: ${getFontFamily(styleProps.headings.h6.font)};
          font-weight: 600;
          padding: 0.6em 0em;
        }
      `;
};
exports.getHeadingCss = getHeadingCss;
